"use strict";
/**
 * Locale definitions, shared by the site and the API.
 *
 * Kept in the shared package so the translation pipeline and the routing
 * layer cannot disagree about which locales exist or which is the source
 * of truth.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALE_META = exports.DEFAULT_LOCALE = exports.SOURCE_LOCALE = exports.LOCALES = void 0;
exports.isLocale = isLocale;
exports.localeMeta = localeMeta;
exports.directionOf = directionOf;
exports.matchLocale = matchLocale;
exports.LOCALES = ['en', 'ar'];
/**
 * English is the source language: posts are written and fact-checked in
 * English, then translated. Arabic is never authored independently, so the
 * two languages cannot state different facts.
 */
exports.SOURCE_LOCALE = 'en';
exports.DEFAULT_LOCALE = 'en';
exports.LOCALE_META = {
    en: {
        code: 'en',
        dir: 'ltr',
        nativeName: 'English',
        englishName: 'English',
        htmlLang: 'en',
        ogLocale: 'en_US',
    },
    ar: {
        code: 'ar',
        dir: 'rtl',
        nativeName: 'العربية',
        englishName: 'Arabic',
        htmlLang: 'ar',
        ogLocale: 'ar_AR',
    },
};
function isLocale(value) {
    return exports.LOCALES.includes(value);
}
function localeMeta(locale) {
    return exports.LOCALE_META[locale];
}
function directionOf(locale) {
    return exports.LOCALE_META[locale].dir;
}
/**
 * Pick the best locale from an Accept-Language header.
 *
 * Only used on `/` to redirect a first-time visitor. Every real page has
 * an explicit prefix, so this never affects a crawler or a shared link.
 */
function matchLocale(acceptLanguage) {
    if (!acceptLanguage)
        return exports.DEFAULT_LOCALE;
    const ranked = acceptLanguage
        .split(',')
        .map((part) => {
        const [tag, ...params] = part.trim().split(';');
        const q = params.find((p) => p.trim().startsWith('q='));
        const quality = q ? Number.parseFloat(q.split('=')[1]) : 1;
        return { tag: tag.trim().toLowerCase(), quality: Number.isNaN(quality) ? 0 : quality };
    })
        .filter((entry) => entry.tag.length > 0)
        .sort((a, b) => b.quality - a.quality);
    for (const { tag } of ranked) {
        // Match the primary subtag, so ar-SA and ar-EG both resolve to ar.
        const primary = tag.split('-')[0];
        if (isLocale(primary))
            return primary;
    }
    return exports.DEFAULT_LOCALE;
}
